import React from 'react';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import './Portfolio.css';

/**
 * Page Portfolio - Galerie de projets réalisés
 * Pour l'instant, affiche un message indiquant que le portfolio sera bientôt disponible
 */
function Portfolio() {
  // Données des projets - Projets réels de Wote
  const projects = [
    {
      id: 1,
      title: 'La Fabrique de Dieu',
      category: 'Application Web',
      description: 'Site web pour l\'Église La Fabrique de Dieu - Plateforme communautaire avec système d\'adhésion de membres, gestion des événements et présentation des programmes',
      technologies: ['Laravel', 'Blade', 'MySQL'],
      image: '/logo3.png', // Tu peux ajouter une vraie capture d'écran du site
      url: 'https://lafabriquededieu.com/'
    },
    {
      id: 2,
      title: 'AltCoach',
      category: 'Application Web',
      description: 'Plateforme de coaching professionnel - Solution complète pour la gestion de sessions de coaching, suivi des clients et planification des rendez-vous',
      technologies: ['Laravel', 'Inertia', 'React', 'MySQL'],
      image: '/logo3.png',
      url: 'https://altcoach.org/'
    },
    {
      id: 3,
      title: 'EbuFact',
      category: 'Application Web',
      description: 'Plateforme de facturation intelligente pour EBUTELO - Système complet de gestion de facturation, devis et suivi des paiements pour entreprises',
      technologies: ['React', 'Laravel', 'MySQL'],
      image: '/logo3.png',
      url: 'https://fact.ebuapp.com/'
    },
    {
      id: 4,
      title: 'EbuResto',
      category: 'Application Web',
      description: 'Plateforme de gestion de restaurant pour EBUTELO - Solution complète pour la gestion des commandes, menus, livraisons et suivi en temps réel pour restaurants',
      technologies: ['React', 'Laravel', 'MySQL'],
      image: '/logo.png',
      url: 'https://resto.ebuapp.com/'
    },
    {
      id: 5,
      title: 'ACADEX',
      category: 'Projet Académique - TFE',
      description: 'Projet de fin d\'études d\'Octavie Lumengu (L2 Informatique 2024-2025, UPC Kinshasa) - Plateforme de gestion académique universitaire avec paiement sécurisé des frais via Mobile Money, gestion des parcours académiques et authentification 2FA',
      technologies: ['Laravel', 'Blade', 'Flutter', 'MySQL'],
      image: '/logo.png'
    },
    {
      id: 6,
      title: 'OMNI RFID',
      category: 'Projet Académique - TFE',
      description: 'Projet de fin d\'études de Dorcas (L3 Informatique Industrielle 2024-2025, ISPT Likasi - Haut-Katanga) - Système de contrôle d\'accès intelligent par cartes RFID avec détection d\'intrusion, alertes email et logs détaillés',
      technologies: ['Django', 'Python', 'MySQL', 'Arduino/ESP32'],
      image: '/logo.png'
    },
    {
      id: 7,
      title: 'Motuna AI',
      category: 'Projet Académique - TFE',
      description: 'Projet de fin d\'études d\'Elihu (L3 Informatique 2024-2025, ISPT Kinshasa) - Assistant IA intelligent pour l\'ISPT Kin avec analyse de documents PDF, LangChain.js, RAG avancé et réponses contextuelles',
      technologies: ['Node.js', 'Express', 'LangChain.js', 'OpenRouter AI'],
      image: '/logo.png'
    },
    {
      id: 8,
      title: 'NoteIA',
      category: 'Projet Académique - TFE',
      description: 'Projet de fin d\'études de Falone Nyota (2024-2025, UPC Kinshasa) - Application collaborative de prise de notes intelligentes avec génération automatique de résumés et quiz par IA, support multi-médias (texte, audio, vidéo, PDF, OCR) et assistant Eden intégré',
      technologies: ['Django', 'Python', 'PostgreSQL', 'OpenRouter AI'],
      image: '/logo.png'
    },
    {
      id: 9,
      title: 'OMNI Full Option',
      category: 'Projet Académique - TFE',
      description: 'Projet de fin d\'études de Synthia Mbombo (L4 Informatique 2024-2025, UPC Kinshasa) - Système de contrôle d\'accès hybride avec reconnaissance faciale Face++, détection en temps réel par webcam, gestion RFID complète et tableau de bord statistiques',
      technologies: ['Django', 'Python', 'MySQL', 'Face++ API'],
      image: '/logo.png'
    }
  ];

  return (
    <div className="portfolio-page">
      <div className="portfolio-header">
        <div className="container">
          <div
            className="page-header-banner"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/female2.png)`,
            }}
          >
            <h1 className="page-title">Portfolio</h1>
            <p className="page-subtitle">
              Découvrez quelques-uns de nos projets réalisés avec succès
            </p>
            <i className="section-subtitle">
              Cliquez sur un projet pour en savoir plus
            </i>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="portfolio-grid">
          {projects.map((project) => (
            <div key={project.id} className="portfolio-card">
              <div className="portfolio-image">
                <img src={project.image} alt={project.title} />
                <div className="portfolio-overlay">
                  <div className="portfolio-tech">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-badge">{tech}</span>
                    ))}
                  </div>
                  {project.url && (
                    <a 
                      href={project.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="portfolio-link-btn"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Voir le site
                    </a>
                  )}
                </div>
              </div>
              <div className="portfolio-content">
                <span className="portfolio-category">{project.category}</span>
                <h3 className="portfolio-title">{project.title}</h3>
                <p className="portfolio-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        <section className="portfolio-cta">
          <h2 className="cta-title">Vous avez un projet en tête ?</h2>
          <p className="cta-description">
            Discutons de votre projet et créons ensemble quelque chose d'exceptionnel
          </p>
          <WhatsAppButton />
        </section>
      </div>
    </div>
  );
}

export default Portfolio;

